import Vue from 'vue'
import App from './App.vue'
import router from './router'
import wxSignature from './utils/wxSignature'
import './libs/FastClick'
import wxTitle from './directives/wx-title'

import './assets/styles/global.scss'

wxSignature()

Vue.config.productionTip = false
Vue.directive('title', wxTitle)

if (process.env.NODE_ENV === 'production') {
  require('./utils/devMode')
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
